export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0034s_0000_Black-&-White-28.b897eaa2.png";